module.exports = __webpack_public_path__ + "images/ac3.png";